import { render, staticRenderFns } from "./PasswordForgot.vue?vue&type=template&id=1baa3026&scoped=true&"
import script from "./PasswordForgot.vue?vue&type=script&lang=ts&"
export * from "./PasswordForgot.vue?vue&type=script&lang=ts&"
import style0 from "./PasswordForgot.vue?vue&type=style&index=0&id=1baa3026&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1baa3026",
  null
  
)

export default component.exports